import { render, staticRenderFns } from "./BrebDialog.vue?vue&type=template&id=c6b9e166&scoped=true&"
import script from "./BrebDialog.vue?vue&type=script&lang=js&"
export * from "./BrebDialog.vue?vue&type=script&lang=js&"
import style1 from "./BrebDialog.vue?vue&type=style&index=1&id=c6b9e166&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b9e166",
  null
  
)

export default component.exports